<template>
  <v-row class="pa-3">
    <div>
      Your agency is currently
      <span v-if="!isSubscribed" class="red--text font-weight-bold">
        Unsubscribed
      </span>
      <span v-else class="green--text font-weight-bold">
        Subscribed
      </span>
      to the
      <strong>{{ name }}</strong> product.
    </div>
  </v-row>
</template>
<script>
export default {
  name: 'ProductCardSubscriptionRow',
  props: {
    isSubscribed: {
      type: Boolean, required: true
    },
    name: {
      type: String, required: true
    }
  }
};
</script>
